var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.12 4.08C12.63 1.722 7.03 3.355 4.608 7.729c-2.421 4.373-.746 9.831 3.743 12.19s10.09.727 12.51-3.647c.534-.964.638-1.806.638-2.806h-1.012c-.014 1-.052 1.47-.529 2.332-2.152 3.887-7.13 5.338-11.12 3.241S3.359 12.09 5.512 8.202c2.152-3.887 7.13-5.338 11.12-3.241a10.1 10.1 0 0 1 3.031 2.502L16.5 7.46v.998h5V3.463h-1V6.85a11.2 11.2 0 0 0-3.38-2.77"
  })));
};
export default SvgRefresh;